/* eslint-disable-next-line max-len */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */

interface WebpackModule {
  default: (
    element: unknown,
    options?: unknown
  ) => void | Record<string, unknown>;
}

export function loadFederatedAssetFactory(
  remoteName: string,
  remoteModule: string
) {
  return async () => {
    await __webpack_init_sharing__('default');
    const container = window[remoteName as unknown as keyof Window];

    // Initialize the container, it may provide shared modules
    await container.init(__webpack_share_scopes__.default);
    const factory = await window[remoteName as unknown as keyof Window].get(
      remoteModule
    );
    const Module = factory();

    return Module as WebpackModule;
  };
}
